import {has} from '@malt/common';
import {notifsEndpointCalled, updateNotifs} from '../../../events/header';

Hop.defineModule('header-notif', (domRoot, params) => {
    const API = '/api/header/notifications/all';
    const IS_MOBILE = params.isMobile || false;

    const CLASSES = {
        NOTIFICATION_CONTENT: 'notification-content',
        NOTIFICATION_CONTENT_OVER_NINE: 'notification-content_superior-to-nine',
    };

    function addSPecificClassForCountSuperiorTo9(notifToDisplay, notifBlock) {
        notifBlock.classList.toggle(CLASSES.NOTIFICATION_CONTENT_OVER_NINE, notifToDisplay && notifToDisplay > 9);
    }

    function buildNotificationContent(count, wrapper) {
        wrapper.innerHTML = count;
        wrapper.classList.add(CLASSES.NOTIFICATION_CONTENT);
        addSPecificClassForCountSuperiorTo9(count, wrapper);
    }

    function displayCurrentIdentitiesNotif(countsToDisplayByMenuEntryIndex) {
        const navList = domRoot.querySelectorAll('[data-menu-item]');

        navList.forEach((item, i) => {
            const notifWrapper = item.querySelector('.notification-wrapper');
            const count = countsToDisplayByMenuEntryIndex[i];

            if (notifWrapper) {
                notifWrapper.classList.add('user-button-notif');

                if (count > 0) {
                    buildNotificationContent(count, notifWrapper);
                } else {
                    notifWrapper.innerHTML = '';
                    notifWrapper.classList.remove(CLASSES.NOTIFICATION_CONTENT);
                }
            }
        });
    }

    function displayAllOtherIdentitiesNotif() {
        const userButton = domRoot.querySelector('[id="mainHeaderIdentityEntry"]');
        const newSpan = document.createElement('span');

        newSpan.classList.add(CLASSES.NOTIFICATION_CONTENT);
        newSpan.classList.add('user-button-notif');

        // On mobile we don't have this selector
        if (userButton) {
            userButton.appendChild(newSpan);
        }
    }

    function displayOtherIdentitiesNotif(notificationCountsByIdentity, currentIdentityId) {
        let additionOfAllNotifs = 0;

        for (const identityId in notificationCountsByIdentity) {
            if (has(notificationCountsByIdentity, identityId)) {
                if (identityId === currentIdentityId) {
                    continue;
                }

                const notificationCountsForIdentity = notificationCountsByIdentity[identityId];

                const notifToDisplay = notificationCountsForIdentity
                    ? notificationCountsForIdentity.dashboardCount + notificationCountsForIdentity.messageCount + notificationCountsForIdentity.missionCount
                    : 0;

                if (notifToDisplay > 0) {
                    const newSpan = document.createElement('span');
                    const newSpanWrapper = getIdentityDomElementById(identityId);

                    if (newSpanWrapper) {
                        newSpan.textContent = notifToDisplay;
                        newSpan.classList.add(CLASSES.NOTIFICATION_CONTENT);
                        newSpanWrapper && newSpanWrapper.appendChild(newSpan);

                        addSPecificClassForCountSuperiorTo9(notifToDisplay, newSpan);
                    }
                }

                additionOfAllNotifs += notifToDisplay;
            }
        }

        if (additionOfAllNotifs > 0) {
            displayAllOtherIdentitiesNotif();
        }
    }

    function getIdentityDomElementById(identityId) {
        const id = IS_MOBILE ? `${identityId}-mobile` : identityId;
        // We can't access getElementById through domRoot
        return domRoot.querySelector(`[id='${id}']`);
    }

    function builAllNotificationsFromResponse(notificationCountsByIdentity, result) {
        const DEFAULT_NOTIFICATION_COUNT = {
            dashboardCount: 0,
            messageCount: 0,
            missionCount: 0,
        };

        const notificationCountsForCurrentIdentity = Object.assign(DEFAULT_NOTIFICATION_COUNT, notificationCountsByIdentity[result.currentIdentityId] || {});

        const countsToDisplayByMenuEntryIndex = [
            notificationCountsForCurrentIdentity.dashboardCount,
            notificationCountsForCurrentIdentity.messageCount,
            notificationCountsForCurrentIdentity.missionCount,
        ];

        displayCurrentIdentitiesNotif(countsToDisplayByMenuEntryIndex);
        displayOtherIdentitiesNotif(notificationCountsByIdentity, result.currentIdentityId);
    }

    function getAllNotifications() {
        return Hop.get(API);
    }

    function formatNotifData() {
        getAllNotifications()
            .then((response) => response.json())
            .then((result) => handleNotifications(result, true))
            .catch((failureResponseOrError) => handleErrors(failureResponseOrError));
    }

    function handleNotifications(response, calledEndpoint = false) {
        const notificationCountsByIdentity = response.notifications;

        if (calledEndpoint) {
            // This module is called 2 times, for desktop and mobile templates
            // From the first endpoint result (desktop template), we trigger this event and sent the response
            // to mobile module
            Hop.events.trigger(notifsEndpointCalled, response);
        }

        if (!notificationCountsByIdentity || Object.keys(notificationCountsByIdentity).length === 0) {
            return;
        }

        builAllNotificationsFromResponse(notificationCountsByIdentity, response);
    }

    function handleErrors(error) {
        if (error.status !== 502) {
            throw error;
        }
    }

    function setListeners() {
        Hop.events.on(updateNotifs, formatNotifData);
    }

    if (!IS_MOBILE) {
        // We call the endpoint here, and trigger the event HEADER_EVENTS.notifsEndpointCalled
        formatNotifData();
    } else {
        Hop.events.on(notifsEndpointCalled, handleNotifications);
    }

    setListeners();

    return function destroy() {
        Hop.events.off(updateNotifs, formatNotifData);
    };
});
